import CryptoJS from "crypto-js";
import { App } from 'vue'
/**
 * AES 加密
 * @param word: 需要加密的文本
 * KEY: // 需要前后端保持一致
 * mode: ECB // 需要前后端保持一致
 * pad: Pkcs7 //前端 Pkcs7 对应 后端 Pkcs5
 */
const KEY = CryptoJS.enc.Utf8.parse('d7b85f6e214abcde')

//加密
const encrypt = (word, keyStr) => {
  keyStr = keyStr ? keyStr : 'abcdefgabcdefg12';
  const key = CryptoJS.enc.Utf8.parse(keyStr); //Latin1 w8m31+Yy/Nw6thPsMpO5fg==
  const srcs = CryptoJS.enc.Utf8.parse(word);
  const encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
};
//解密
const decrypt = (word, keyStr) => {
  keyStr = keyStr ? keyStr : 'abcdefgabcdefg12';
  const key = CryptoJS.enc.Utf8.parse(keyStr); //Latin1 w8m31+Yy/Nw6thPsMpO5fg==
  const decrypt = CryptoJS.AES.decrypt(word, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return CryptoJS.enc.Utf8.stringify(decrypt).toString();
};

//密码md5加密
export const MD5 = (str) => {
  if (str) {
    const PASSWORD_KEY = "o2aeyMl84e";
    return CryptoJS.MD5(CryptoJS.MD5(PASSWORD_KEY) + PASSWORD_KEY + CryptoJS.MD5(str.trim())).toString();
  }
};

export function setupCrypto(app: App) {

  app.config.globalProperties.$AES_Encrypt = encrypt //全局加密
  app.config.globalProperties.$AES_Decrypt = decrypt //全局解密
  app.config.globalProperties.$MD5 = MD5 //密码md5加密

}

